import { mediaItems } from '@/mocks/homeData';

const imageUrls: Record<string, string> = {
  'media-card-01': 'https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20photography%20scene%20with%20warm%20ambient%20lighting%20depicting%20celebrity%20entertainment%20news%20theme%2C%20abstract%20composition%20with%20soft%20bokeh%20background%20in%20warm%20orange%20and%20cream%20tones%2C%20magazine%20cover%20style%20layout%20with%20elegant%20minimalist%20design%2C%20sophisticated%20visual%20storytelling%20with%20high%20contrast%20and%20clean%20aesthetic&width=640&height=360&seq=media-card-01&orientation=landscape',
  'media-card-02': 'https://readdy.ai/api/search-image?query=A%20behind%20the%20scenes%20television%20studio%20atmosphere%20with%20dramatic%20lighting%20and%20warm%20color%20palette%2C%20abstract%20representation%20of%20variety%20show%20production%20with%20geometric%20shapes%20and%20soft%20gradients%20in%20amber%20and%20peach%20tones%2C%20editorial%20style%20composition%20with%20cinematic%20mood%20and%20minimalist%20design%20elements&width=640&height=360&seq=media-card-02&orientation=landscape',
  'media-card-03': 'https://readdy.ai/api/search-image?query=A%20conceptual%20editorial%20image%20representing%20consumer%20protection%20and%20product%20quality%20issues%2C%20warm%20lighting%20with%20soft%20shadows%20on%20a%20clean%20minimalist%20background%2C%20abstract%20composition%20with%20geometric%20elements%20in%20terracotta%20and%20cream%20tones%2C%20sophisticated%20magazine%20editorial%20aesthetic%20with%20balanced%20negative%20space&width=640&height=360&seq=media-card-03&orientation=landscape',
  'media-card-04': 'https://readdy.ai/api/search-image?query=A%20dramatic%20concert%20stage%20atmosphere%20with%20warm%20spotlight%20and%20abstract%20musical%20elements%2C%20editorial%20photography%20style%20with%20soft%20golden%20hour%20lighting%20and%20atmospheric%20haze%2C%20minimalist%20composition%20with%20clean%20negative%20space%20and%20warm%20amber%20color%20palette%2C%20sophisticated%20visual%20design&width=640&height=360&seq=media-card-04&orientation=landscape',
  'media-card-05': 'https://readdy.ai/api/search-image?query=A%20modern%20entertainment%20news%20studio%20setting%20with%20warm%20ambient%20lighting%2C%20abstract%20representation%20of%20pop%20culture%20and%20celebrity%20news%20with%20geometric%20design%20elements%20in%20warm%20coral%20and%20cream%20tones%2C%20editorial%20layout%20aesthetic%20with%20clean%20lines%20and%20sophisticated%20magazine%20style%20composition&width=640&height=360&seq=media-card-05&orientation=landscape',
};

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            精彩内容
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">热门视频</h2>
          <p className="text-sm text-foreground-600 mt-2">精选最热门爆料视频，一站式浏览精彩内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.slice(0, 3).map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer group"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={imageUrls[item.imageSeq]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors"></div>
                <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded">
                  {item.duration}
                </div>
                <div className="absolute top-2 left-2">
                  <span className="text-[10px] font-semibold bg-primary-500 text-background-50 px-2 py-0.5 rounded">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 line-clamp-2">{item.title}</h3>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次浏览</span>
                </div>
              </div>
            </div>
          ))}

          {mediaItems.slice(3).map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer group hidden lg:block"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={imageUrls[item.imageSeq]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors"></div>
                <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded">
                  {item.duration}
                </div>
                <div className="absolute top-2 left-2">
                  <span className="text-[10px] font-semibold bg-primary-500 text-background-50 px-2 py-0.5 rounded">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 line-clamp-2">{item.title}</h3>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次浏览</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}